{
  "deployment": {
    "server": false,
    "demo": true,
    "demoTestingSections": [],
    "demoTrials": 8
  },
  "demoNeeds": {
    "EN": ["power", "hope", "friendship"],
    "DE": ["Macht", "Hoffnung", "Freundschaft"],
    "JP": ["力", "希望", "友情"],
    "NL": ["kracht", "hoop", "vriendschap"]
  },
  "demoProfiles": {
    "EN": {
      "profiles": [
        [
          {
            "profileId": "1",
            "brandName": "Pontiac",
            "productSegment": "sedan.png",
            "productPerformance": "2",
            "productComfort": "4",
            "productPrice": "20000",
            "brandImage": "logo_pontiac.png"
          },

          {
            "profileId": "2",
            "brandName": "Oldsmobile",
            "productSegment": "roadster.png",
            "productPerformance": "2",
            "productComfort": "3",
            "productPrice": "25000",
            "brandImage": "logo_oldsmobile.png"
          }
        ],
        [
          {
            "profileId": "3",
            "brandName": "Hummer",
            "productSegment": "suv.png",
            "productPerformance": "5",
            "productComfort": "1",
            "productPrice": "25000",
            "brandImage": "logo_hummer.png"
          },

          {
            "profileId": "4",
            "brandName": "Pontiac",
            "productSegment": "sedan.png",
            "productPerformance": "2",
            "productComfort": "2",
            "productPrice": "15000",
            "brandImage": "logo_pontiac.png"
          }
        ],
        [
          {
            "profileId": "5",
            "brandName": "Hummer",
            "productSegment": "suv.png",
            "productPerformance": "4",
            "productComfort": "5",
            "productPrice": "35000",
            "brandImage": "logo_hummer.png"
          },

          {
            "profileId": "6",
            "brandName": "Oldsmobile",
            "productSegment": "roadster.png",
            "productPerformance": "3",
            "productComfort": "2",
            "productPrice": "20000",
            "brandImage": "logo_oldsmobile.png"
          }
        ],
        [
          {
            "profileId": "7",
            "brandName": "Pontiac",
            "productSegment": "sedan.png",
            "productPerformance": "3",
            "productComfort": "2",
            "productPrice": "35000",
            "brandImage": "logo_pontiac.png"
          },

          {
            "profileId": "8",
            "brandName": "Oldsmobile",
            "productSegment": "roadster.png",
            "productPerformance": "2",
            "productComfort": "3",
            "productPrice": "25000",
            "brandImage": "logo_oldsmobile.png"
          }
        ],
        [
          {
            "profileId": "9",
            "brandName": "Hummer",
            "productSegment": "suv.png",
            "productPerformance": "3",
            "productComfort": "4",
            "productPrice": "15000",
            "brandImage": "logo_hummer.png"
          },

          {
            "profileId": "10",
            "brandName": "Pontiac",
            "productSegment": "sedan.png",
            "productPerformance": "1",
            "productComfort": "3",
            "productPrice": "15000",
            "brandImage": "logo_pontiac.png"
          }
        ]
      ]
    },

    "DE": {
      "profiles": [
        [
          {
            "profileId": "1",
            "brandName": "Pontiac",
            "productSegment": "sedan.png",
            "productPerformance": "2",
            "productComfort": "4",
            "productPrice": "20000",
            "brandImage": "logo_pontiac.png"
          },

          {
            "profileId": "2",
            "brandName": "Oldsmobile",
            "productSegment": "roadster.png",
            "productPerformance": "2",
            "productComfort": "3",
            "productPrice": "25000",
            "brandImage": "logo_oldsmobile.png"
          }
        ],
        [
          {
            "profileId": "3",
            "brandName": "Hummer",
            "productSegment": "suv.png",
            "productPerformance": "5",
            "productComfort": "1",
            "productPrice": "25000",
            "brandImage": "logo_hummer.png"
          },

          {
            "profileId": "4",
            "brandName": "Pontiac",
            "productSegment": "sedan.png",
            "productPerformance": "2",
            "productComfort": "2",
            "productPrice": "15000",
            "brandImage": "logo_pontiac.png"
          }
        ],
        [
          {
            "profileId": "5",
            "brandName": "Hummer",
            "productSegment": "suv.png",
            "productPerformance": "4",
            "productComfort": "5",
            "productPrice": "35000",
            "brandImage": "logo_hummer.png"
          },

          {
            "profileId": "6",
            "brandName": "Oldsmobile",
            "productSegment": "roadster.png",
            "productPerformance": "3",
            "productComfort": "2",
            "productPrice": "20000",
            "brandImage": "logo_oldsmobile.png"
          }
        ],
        [
          {
            "profileId": "7",
            "brandName": "Pontiac",
            "productSegment": "sedan.png",
            "productPerformance": "3",
            "productComfort": "2",
            "productPrice": "35000",
            "brandImage": "logo_pontiac.png"
          },

          {
            "profileId": "8",
            "brandName": "Oldsmobile",
            "productSegment": "roadster.png",
            "productPerformance": "2",
            "productComfort": "3",
            "productPrice": "25000",
            "brandImage": "logo_oldsmobile.png"
          }
        ],
        [
          {
            "profileId": "9",
            "brandName": "Hummer",
            "productSegment": "suv.png",
            "productPerformance": "3",
            "productComfort": "4",
            "productPrice": "15000",
            "brandImage": "logo_hummer.png"
          },

          {
            "profileId": "10",
            "brandName": "Pontiac",
            "productSegment": "sedan.png",
            "productPerformance": "1",
            "productComfort": "3",
            "productPrice": "15000",
            "brandImage": "logo_pontiac.png"
          }
        ]
      ]
    }
  },
  "needsphere": {
    "EN": {
      "Dominanz": ["leadership", "strength", "status", "performance"],
      "Bindung": ["care", "sociability", "protection", "closeness"],
      "Autonomie": ["adventure", "freedom", "suspense", "variety"],
      "Stabilität": ["safety", "discipline", "order", "accuracy"]
    },
    "DE": {
      "Dominanz": ["Führung", "Stärke", "Status", "Leistung"],
      "Bindung": ["Fürsorge", "Geselligkeit", "Geborgenheit", "Nähe"],
      "Autonomie": ["Abenteuer", "Freiheit", "Spannung", "Vielfalt"],
      "Stabilität": ["Sicherheit", "Disziplin", "Ordnung", "Sorgfalt"]
    },
    "JP": {
      "Dominanz": ["リーダーシップ", "強さ", "ステータス", "実績"],
      "Bindung": ["配慮", "社交性", "安心", "親密"],
      "Autonomie": ["冒険", "自由", "スリル", "多様性"],
      "Stabilität": ["安全", "規律", "秩序", "正確さ"]
    },
    "NL": {
      "Dominanz": ["leiderschap", "kracht", "status", "prestatie"],
      "Bindung": ["zorg", "gezelligheid", "bescherming", "nabijheid"],
      "Autonomie": ["avontuur", "vrijheid", "spanning", "afwisseling"],
      "Stabilität": ["veiligheid", "discipline", "orde", "nauwkeurigheid"]
    }
  },
  "needsphereBrand": {
    "EN": {},
    "DE": {},
    "JP": {},
    "NL": {}
  },
  "needsphereCustom": {
    "EN": {
      "X": ["R1", "R2", "R3", "R4"],
      "Y": ["R5", "R6", "R7", "R8"]
    },
    "DE": {
      "X": ["R1", "R2", "R3", "R4"],
      "Y": ["R5", "R6", "R7", "R8"]
    },
    "NL": {
      "X": ["R1", "R2", "R3", "R4"],
      "Y": ["R5", "R6", "R7", "R8"]
    },
    "JP": {}
  },
  "brandImages": [
    {
      "brandName": "testBrand",
      "imageName": "sample.jpeg"
    }
  ],
  "needsRepetition": 10,
  "demoNeedsRepetition": 2,
  "fadeOutTime": 2500,
  "fadeOutTimeLong": 5000,
  "fadeOutOpacity": 0.1,
  "proceedAfter": 2500,
  "proceedAfterLong": 5000,
  "minimumReactionTime": 200,
  "decisionKeys": {
    "standard": {
      "keys": ["x", "n"],
      "labels": {
        "EN": ["Fits not", "Fits"],
        "DE": ["Passt nicht", "Passt"],
        "JP": ["重要でない", "重要"],
        "NL": ["Past niet", "Past"]
      },
      "continue": {
        "space": {
          "EN": "space bar",
          "DE": "Leertaste",
          "JP": "スペースバー",
          "NL": "spatiebalk"
        }
      },
      "FC-labels": {
        "EN": ["left", "right"],
        "DE": ["links", "rechts"],
        "JP": ["左", "右"],
        "NL": ["links", "rechts"]
      }
    },
    "agreement": {
      "keys": ["1", "2", "3", "4"],
      "labels": {
        "EN": ["strongly disagree", "disagree", "agree", "strongly agree"],
        "DE": [
          "stimme überhaupt nicht zu",
          "stimme nicht zu",
          "stimme zu",
          "stimme sehr zu"
        ],
        "JP": ["全く同意しない", "同意しない", "同意する", "非常に同意する"],
        "NL": ["zeer mee oneens", "mee oneens", "mee eens", "zeer mee eens"]
      }
    },
    "IAT": {
      "keys": ["e", "i"],
      "labels": {
        "EN": ["left", "right"],
        "DE": ["links", "rechts"],
        "JP": ["左", "右"],
        "NL": ["links", "rechts"]
      }
    },
    "priming": {
      "keys": ["e", "i"],
      "labels": {
        "EN": ["word", "not word"],
        "DE": ["Wort", "Kein Wort"],
        "JP": ["左", "右"],
        "NL": ["woord", "geen woord"]
      }
    },
    "conjoint": {
      "keys": ["e", "i"],
      "labels": {
        "EN": ["word", "not word"],
        "DE": ["Option A", "Option B"],
        "JP": ["左", "右"],
        "NL": ["woord", "geen woord"]
      }
    }
  },
  "countdownLength": 3,
  "IATQuestionDisplayLength": 3,
  "fingerPlacementDisplayLength": 5,
  "resetResultsAfterReload": false,
  "defaultLanguage": "EN",
  "irrelevantSections": ["pdf", "section-divider"]
}
